import React from 'react';
import { isArray } from '@agilepoint/utils-common';
import { To, useLocation, useNavigate } from 'react-router-dom';

interface IQueryParams {
    [key: string]: string | string[];
}

export function createQueryString(queries: IQueryParams): string {
    return Object.entries(queries).map(([key, value]) => (`${key}=${isArray(value) ? value.join(';') : value}`)).join('&');
}

export function useNavigateManager() {
    const navigate = useNavigate();
    const location = useLocation();

    return React.useMemo(() => ({
        push(args: To & { queryParams?: IQueryParams; }) {
            const { queryParams } = args;
            const queryString = queryParams ? createQueryString(args.queryParams!) : location.search;
            if (typeof args !== 'string') args.search = queryString;
            navigate(args);
        },
        replace(args: To & { queryParams?: IQueryParams; }) {
            const { queryParams } = args;
            const queryString = queryParams ? createQueryString(args.queryParams!) : location.search;
            if (typeof args !== 'string') args.search = queryString;
            navigate(args, { replace: true });
        },
        goBack() {
            navigate(-1);
        }
    }), [location.search, navigate]);
}
